import { render } from "./ReceivedCallsMenu.vue?vue&type=template&id=423949a4&scoped=true"
import script from "./ReceivedCallsMenu.vue?vue&type=script&lang=js"
export * from "./ReceivedCallsMenu.vue?vue&type=script&lang=js"

import "./ReceivedCallsMenu.vue?vue&type=style&index=0&id=423949a4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\timdi\\Desktop\\funkapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-423949a4"]])

export default __exports__